import AdminHomeView from "./patient/AdminHomeView";
import PatientForm from "./patient/PatientForm";
import PatientSections from "./patient/PatientSections";
import BedList from "./bed/BedList";
import BedForm from "./bed/BedForm";
import BedAddForm from "./bed/BedAddForm";
import BedSearch from "./bed/BedSearch";
import FormDetail from "./forms/formDetail";
import FormList from "./forms/formsList";
import SectionAdd from "./forms/sectionAdd";
import FormPreview from "./forms/formPreview";
import DocSetup from "./doctor/docSetup";
import DocVisitFee from "./doctor/docVisitFee";
import ServiceMaster from "./serviceCategory/ServiceMaster";
import Search from "./serviceCategory/Search";
import DiagnosisMaster from "./diagnosis/DiagnosisMaster";
import SearchDiagnosis from "./diagnosis/SearchDiagnosis";
import ListDoctor from "./doctor/ListDoctor";
import Login from "./login/Login";
import ListPatient from "./doctor/ListPatient";
import Dashboard from "./doctor/Dashboard";
import SearchDept from "./doctor/SearchDept";
import BtnCellRenderer from "./common/BtnCellRenderer";
import CustomTooltip from "./common/CustomTooltip";
import DoctorHomeView from "./patient/DoctorHomeView";
//import PatientPrescriptionLayout from './patient/PatientPrescriptionLayout';
import PrescriptionLayoutModel from "./patient/PrescriptionLayoutModel";
import LayoutHeader from "./common/LayoutHeader";
import AttachOptions from "./patient/AttachOptions";
import PatientEditForm from "./patient/PatientEditForm";
import BasicLayoutHeader from "./common/BasicLayoutHeader";
import Dropzone from "./patient/Dropzone";
import FileUploadPreview from "./patient/FileUploadPreview";
import PatientListing from "./appointmentList/PatientListing";
import GiveAppointment from "./appointmentList/GiveAppointment";
import PatientRevisit from "./appointmentList/PatientRevisit";
import PatientRevisitModal from "./appointmentList/PatientRevisitModal";
import AddPatientmodel from "./appointmentList/AddPatientmodel.js";
import PatientSchema from "./patient/PatientSchema";
import Zoom from "./zoommeeting/zoom";
import Zoommeeting from "./zoommeeting/zoommeeting";
import ZoomNotes from "./zoommeeting/ZoomNotes";
import ZoomMeetingReviewModel from "./zoommeeting/ZoomMeetingReviewModel";
import NotesLabel from "./notes-label/NotesLabel";
import Discharge from "./discharge/dischargeSummary";
import MnhDischargeSummary from "./discharge/mnhdischargeSummary.js";
import TemplatePreview from "./patient/TemplatePreview";
import Attachments from "./patient/Attachments";
import PackageService from "./patient/PackageService";
import ProcedureListing from "./patient/ProcedureListing";
import StandaloneProcedureListing from "./patient/StandaloneProcedureListing";
import AppointmentScheduleModal from "./appointmentList/AppointmentScheduleModal";
import AdminAppointment from "./appointmentList/AdminAppointment.js";
import PrintDischargeSummary from "./discharge/dischargePrint.js";
import PrintMnhDischargeSummary from "./discharge/mnhdischargePrint.js";
import NotesPrint from "./patient/notesPrint.js";
// import MnhNotesPrint from './patient/mnhNotesPrint.js';
import DoctorRegister from "./master/doctor/DoctorRegister";
import DoctorList from "./master/doctor/DoctorList";
import DoctorListGrid from "./master/doctor/DoctorListGrid";
import addDoctor from "./master/doctor/addDoctor";
import InsuranceProcedureInput from "./Insurance/InsuranceProcedureInput";
import insuranceMasteradd from "./master/insurance/insuranceMasteradd";
import Tpaadd from "./master/insurance/tpaadd";
import insuranceMasterList from "./master/insurance/insuranceMasterList";
import tpamasterlist from "./master/insurance/tpamasterlist";
import InsuranceProcedureSettlement from "./Insurance/InsuranceProcedureSettlement";
import InsuranceProcedureListing from "./Insurance/InsuranceProcedureListing";
import pdfprint from "./patient/pdfprint";
import AddConsultant from "./common/AddConsultant";
// Patient Case Study create/edit form and stacked history screen.
import AddCaseStudy from "./common/AddCaseStudy";
import PatientCaseStudyManager from "./common/PatientCaseStudyManager";
import roomMasterList from "./master/roomMaster/roomMasterList";
import RoomMasterAdd from "./master/roomMaster/roomMasterAdd";
import Services from "./common/Services";
import VisitsByType from "../components/nurse/VisitsByType";
import Payment from "./payment/Payment";
import PaymentForClinic from "./payment/PaymentForClinic";
import CreditCardPayment from "./payment/CreditCardPayment";
import CashPayment from "./payment/CashPayment";
import UpiPayment from "./payment/UpiPayment";
import Reports from "./Reports/reports";
import TokenDashBoard from "./TokenDashBoard/tokendashboard";
import TokenDashBoardDetails from "./TokenDashBoardDetails/tokendashboarddetails";
import TokenPrint from "./patient/TokenPrint";
import RegistrationCard from "./patient/RegistrationCard";
import LabReportPrint from "../shared/schema/LabReportPrint";
// import RadiologyReportPrint from '../mnh/radiologyReportPrint.js';
import RadiologyPrint from "../mnh/RadiologyPrint.js";
import DischargePrint from "./patient/DischargePrint";
import Vouchers from "./patient/Vouchers";
import ActiveTokenPatients from "./TokenDashBoard/activeTokenPatients";
import Package from "./master/package/package";
import PackageMasterAdd from "./master/package/packageMasterAdd";
import Notes from "./patient/Notes";
import MnhNotes from "./patient/MnhNotes.js";
import MyReports from "./MyReports/MyReports.js";
import Prescription from "./ehr/Prescription";
//import StaffList from './master/Staff/stafflist';
//impoListStaff from './master/Staff/LIstStaff';
//import AddStaff from './master/rt  addStaff from '../core/actions/doctorActions';
//import Staff/AddStaffrrr

import AddStaff from "./master/Staff/AddStaff";
import StaffList from "./master/Staff/StaffList";
import ERPBilling from "./erp-billing/ERPBilling.js";
import ERPServicesList from "./erp-billing/ERPServicesList.js";
import ERPProductSearch from "./erp-billing/ERPProductSearch";
import ERPInvoice from "./erp-billing/ERPInvoice.js";
import ERPPayment from "./erp-billing/ERPPayment.js";
import Abdominal from "./radiology/Abdominal.js";
import Follicular from "./radiology/Follicular.js";
import DopplerStudy from "./radiology/DopplerStudy.js";
import RadiologyTemplate from "./patient/RadiologyTemplate.js";
import Scrotum from "./radiology/Scrotum.js";
import MoveToBilling from "./appointmentList/MoveToBilling.js";
import labPackageList from "./master/lab/labPackageList.js";
import addLabPackage from "./master/lab/addPackage.js";
import { Loading } from "./erp-billing/Loading.js";
import RoomManageDetails from "./Room/RoomManagementDetails.js";
import AllCustomerInvoicePaymentRequest from "./erp-billing/AllCustomerInvoicePaymentRequest.js";
import ErrorScreen from "../shared/helper/ErrorScreen.js";
import ChangePassword from "./master/Staff/ChangePassword.js";
import PatientOneStepOnboard from "./patient/PatientOneStepOnboard.js";
import ConsentFormsDashboard from "./patient/ConsentFormsDashboard.js";
import SurgeryConsentForm from "./consentForms/SurgeryConsentForm.js";
import AdmissionConsentForm from "./consentForms/AdmissionConsentForm.js";
import PanchakarmaConsentForm from "./consentForms/PanchakarmaConsentForm.js";
import PainAssessmentForm from "./consentForms/Painassessmentform.js";
import BlobUrlViewer from "./patient/print/BlobUrlViewer.js";
import printPatientCard from "./patient/print/PrintPatientCard.js";
import VedamaayuDischargeSummary from "../vm/vedamaayuDischargeSummary";
import VedamaayuDischargePrint from "../vm/vedamaayuDischargePrint";
import vedamaayuNotes from "../vm/vedamaayuNotes.js";
import VedamaayuDoctorNotes from "../vm/VedamaayuDoctorNotes";
import VedamaayuNurseNotes from "../vm/VedamaayuNurseNotes";



const Components = {
  AdminHomeView,
  PatientForm,
  PatientSections,
  BedList,
  BedForm,
  BedAddForm,
  BedSearch,
  FormDetail,
  SectionAdd,
  FormList,
  FormPreview,
  DocSetup,
  DocVisitFee,
  ServiceMaster,
  Search,
  DiagnosisMaster,
  SearchDiagnosis,
  Login,
  StaffList,
  ListDoctor,
  ListPatient,
  AddStaff,
  Dashboard,
  SearchDept,
  BtnCellRenderer,
  CustomTooltip,
  DoctorHomeView,
  LabReportPrint,
  // RadiologyReportPrint,
  RadiologyPrint,
  //PatientPrescriptionLayout,
  PrescriptionLayoutModel,
  LayoutHeader,
  AttachOptions,
  PatientEditForm,
  BasicLayoutHeader,
  Dropzone,
  FileUploadPreview,
  PatientListing,
  GiveAppointment,
  PatientRevisit,
  PatientRevisitModal,
  AddPatientmodel,
  PatientSchema,
  Zoom,
  Zoommeeting,
  ZoomNotes,
  ZoomMeetingReviewModel,
  NotesLabel,
  Discharge,
  MnhDischargeSummary,
  TemplatePreview,
  Attachments,
  PackageService,
  ProcedureListing,
  StandaloneProcedureListing,
  AppointmentScheduleModal,
  AdminAppointment,
  DoctorRegister,
  DoctorList,
  DoctorListGrid,
  addDoctor,
  InsuranceProcedureListing,
  InsuranceProcedureInput,
  InsuranceProcedureSettlement,
  insuranceMasteradd,
  Tpaadd,
  insuranceMasterList,
  tpamasterlist,
  pdfprint,
  AddConsultant,
  AddCaseStudy,
  PatientCaseStudyManager,
  roomMasterList,
  RoomMasterAdd,
  Services,
  VisitsByType,
  Payment,
  PaymentForClinic,
  CashPayment,
  CreditCardPayment,
  UpiPayment,
  Reports,
  TokenDashBoard,
  TokenDashBoardDetails,
  TokenPrint,
  DischargePrint,
  Vouchers,
  ActiveTokenPatients,
  RegistrationCard,
  Package,
  PackageMasterAdd,
  Notes,
  MnhNotes,
  PrintDischargeSummary,
  PrintMnhDischargeSummary,
  NotesPrint,
  // MnhNotesPrint,
  Prescription,
  MyReports,
  ERPBilling,
  ERPServicesList,
  ERPProductSearch,
  ERPPayment,
  Abdominal,
  Follicular,
  DopplerStudy,
  RadiologyTemplate,
  Scrotum,
  MoveToBilling,
  labPackageList,
  addLabPackage,
  Loading,
  RoomManageDetails,
  AllCustomerInvoicePaymentRequest,
  ErrorScreen,
  ChangePassword,
  PatientOneStepOnboard,
  ConsentFormsDashboard,
  SurgeryConsentForm,
  AdmissionConsentForm,
  PanchakarmaConsentForm,
  PainAssessmentForm,
  BlobUrlViewer,
  printPatientCard,
  VedamaayuDischargeSummary,
  VedamaayuDischargePrint,
  vedamaayuNotes,
  VedamaayuDoctorNotes,
  VedamaayuNurseNotes,
};

export default Components;
